import './notified.scss';

export default () => {

};
